// extracted by css-extract-rspack-plugin
export default {"twoFactorConfirm":"twoFactorConfirm-Nr9c5U","twoFactorConfirmLabel":"twoFactorConfirmLabel-KLcBtW","twoFactorConfirmRow":"twoFactorConfirmRow-JYUuUl"};